import React from 'react'

import clsx from 'clsx'
import PropTypes from 'prop-types'
import { Button } from '@material-ui/core'

import usePrimaryBannerPreview from 'hooks/usePrimaryBannerPreview'

import styles from './styles'
import constants from 'constants/index'

const BannerActionButton = ({ kind }) => {
  const { previewTexts, isCompact, isMobile, isFixed, isFull, ...context } =
    usePrimaryBannerPreview()

  const useStyles = styles({ isCompact, isMobile, isFixed, isFull })
  const classes = useStyles()

  const { variant, color, classNameKey, handlerKey, labelKey } =
    constants.cookies.banner.PRIMARY_BANNER_ACTION_BUTTONS[kind]

  return (
    <Button
      className={clsx(classes.button, classes[classNameKey])}
      variant={variant}
      color={color}
      onClick={context[handlerKey]}
    >
      {previewTexts[labelKey]}
    </Button>
  )
}

BannerActionButton.propTypes = {
  kind: PropTypes.oneOf(['settings', 'reject', 'accept']).isRequired,
}

export default BannerActionButton
